import CommentEditForm from "./comment-edit-form";

const CommentsForms = {
    Edit: CommentEditForm,
};

export default CommentsForms;
